import React, { useState, useCallback, useEffect } from "react";
import { Icon, message, Row, Col, Button, Input, Divider, Radio,Slider as AntSlider } from "antd";
import moment from "moment";
import { useDispatch } from "react-redux";
import { figurenames, figures } from "../../constants";
import { Wrapper, Block, HeaderOptions, ThreeBox } from "./styles";
import Carousel from "../../components/carousel";
import Select from "../../components/select";
import Slider from "../../components/slider";
import ThreeFigure from "../../components/three-figure";
import { grades } from "../../constants";
import { useTranslation } from 'react-i18next';

const SelectOptions = [
  {
    key: 0,
    name: "prototipo",
    value: "prototype"
  },
  {
    key: 1,
    name: "catálogo",
    value: "catalogue"
  }
];

const slidersKeys = {
  hard_coat: "hard_coat",
  hardness_required: "hardness_required"
};

const desingDefaultValues = {
  articleName: "",
  isPrototype: false,
  grade: 1,
  figure: [figures["cylinder"]],
  selected_figure: "cylinder",
  hard_coat: 20,
  hardness_required: 700,
  calidadP: 5
};

const Articulo = ({ desing = desingDefaultValues, back = false, close, changeTitle }) => {
  const [state, setState] = useState(desing);
  const dispath = useDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    changeTitle && changeTitle("new_article");
  }, [changeTitle]);

  const figureData = figurenames[state.selected_figure];

  const handleChangueGrade = ({ value }) => setState({ ...state, grade: value });

  const handleChangePrototype = prototype => {
    const { value } = prototype.target;
    const { value: prototypeValue } = SelectOptions.find(el => el.key === value);

    let isPrototype = false;
    if (prototypeValue === "prototype") isPrototype = true;
    if (prototypeValue === "catalogo") isPrototype = false;

    setState({ ...state, isPrototype });
  };

  const handleSaveArticle = () => {
    isActive() && saveData();
    back && close();
  };

  const RenderFigureSlider = useCallback(
    ({ name, min, max, figureKey, unit }) => {
      const figure = state.figure[0].values;
      
      const [value] = Object.entries(figure).find(([figKey]) => figKey === figureKey);
      
      const callback = value => {
        setState(prevState => ({
          ...prevState,
          figure: [
            {
              name: prevState.figure[0].name,
              values: { ...prevState.figure[0].values, [figureKey]: value }
            }
          ]
        }));
      };

      return slider({ name, min, max, value, callback, unit });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [state.selected_figure]
  );

  const RenderSlider = useCallback(
    ({ name, min, max, unit, findKey }) => {
      const value = state[findKey];
      const callback = v => {
        if (findKey === slidersKeys.hard_coat) setState(prevState => ({ ...prevState, hard_coat: v }));

        if (findKey === slidersKeys.hardness_required) setState(prevState => ({ ...prevState, hardness_required: v }));
      };

      return slider({ name, min, max, unit, value, callback });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [state.articleName]
  );

  const slider = ({ name, min, max, value, unit, callback }) => {
    return <Slider name={name} min={min} max={max} unit={unit} value={value} callback={callback} />;
  };

  const getMin2slider = name => {
    return name === "radius"
      ? 50
      : name === "height"
      ? 100
      : name === "tube"
      ? 70
      : name === "width"
      ? 100
      : name === "length"
      ? 100
      : name === "depth"
      ? 100
      : name === "angle"
      ? 0
      : 0;
  };

  const getMax2slider = name => {
    return name === "radius"
      ? 750
      : name === "height"
      ? 4000
      : name === "tube"
      ? 350
      : name === "width"
      ? 4000
      : name === "length"
      ? 4000
      : name === "depth"
      ? 4000
      : name === "angle"
      ? 90
      : 0;
  };
  const marksAgitation = {
    0: "",
    1: "1p",
    2: "2p",
    3: "3p",
    4: "4p",
    5: "5p"
  };
  const handleChangueArticleName = e => {
    setState({ ...state, articleName: e.target.value });
  };

  const isActive = () => {
    return state && state.articleName.length > 0;
  };

  const saveData = () => {
    if (state.type === "update") {
      dispath({
        type: "UPDATE_DESING",
        state: { ...state, date: moment().format() }
      });

      message.success(t('alerts.data_updated'));
    } else {
      const save = {
        id: new Date().getTime(),
        articleName: state.articleName,
        isPrototype: state.isPrototype,
        grade: state.grade,
        figure: [state.figure[0]],
        selected_figure: state.selected_figure,
        hard_coat: state.hard_coat,
        hardness_required: state.hardness_required,
        date: moment().format(),
        calidadP:puntosCalidad
      };
      dispath({ type: "ADD_DESING", save });
      message.success(t('alerts.article_added'));
      setState({
        ...state,
        articleName: ""
      });
    }
  };

  const onChangeSelectedFigure = selected_figure => {
    setState({
      ...state,
      selected_figure,
      figure: [figures[selected_figure]]
    });
  };

  const radioStyle = {
    display: "block",
    width: "100%",
    borderRadius: "4px",
    marginBottom: "10px",
    textAlign: "center"
  };

  const [puntosCalidad,setPuntosCalidad] = useState(3)
  return (
    <Wrapper>
      <Row style={{ margin: 0 }} gutter={[16, 16]}>
        <Col xl={24} lg={24}>
          <Row style={{ marginBottom: 20 }} gutter={[16, 16]} type="flex" justify="space-between">
            <Col>
              <Input
                prefix={<Icon type="profile" style={{ color: "rgba(0,0,0,.25)" }} />}
                value={state ? state.articleName : ""}
                placeholder={t('placeholder.no_title')}
                onChange={handleChangueArticleName}
              />
            </Col>
            <Col>
              {back && (
                <Button onClick={() => close()}>
                  <Icon type="close" />
                  {t('button.cancel')}
                </Button>
              )}
              {back && <Divider type="vertical"></Divider>}
              <Button type="primary" disabled={!isActive()} onClick={() => handleSaveArticle()}>
                <Icon type="save" />
                {state.type ? t('button.update') : t('button.save')}
              </Button>
            </Col>
          </Row>
          <Row style={{ margin: 0 }} gutter={[16, 16]}>
            <Col lg={8} md={24}>
              <Col span={24}>
                <HeaderOptions style={{ marginBottom: "20px" }}>{t('headers.article.figure_type')}</HeaderOptions>
                <Carousel defaultValue={state.selected_figure} onChange={onChangeSelectedFigure} />
                <Block style={{ marginTop: "20px" }}>
                  <Select values={SelectOptions} defaultValue={state.isPrototype ? 0 : 1} callback={handleChangePrototype} />
                </Block>
              </Col>

              <Col span={24}>
                <ThreeBox>
                  <ThreeFigure figureData={state.figure[0]} />
                </ThreeBox>
              </Col>
            </Col>
            <Col lg={8} md={24}>
              <Col span={24} style={{ minHeight: "250px" }}>
                <HeaderOptions>{t('headers.article.piece_geometry')}</HeaderOptions>
                {figureData.map(figure => {
                  return (
                    <Col key={figure.key} span={24}>
                      <RenderFigureSlider
                        key={figure.key}
                        figureKey={figure.key}
                        name={t('labels.measurements.'+figure.key)}
                        min={getMin2slider(figure.key)}
                        max={getMax2slider(figure.key)}
                        unit="mm"
                      />
                    </Col>
                  );
                })}
              </Col>
              <Col span={24} style={{ minHeight: "250px",marginTop:-30 }}>
                <HeaderOptions>{t('headers.article.quality_points')}</HeaderOptions>
                <AntSlider
                  marks={marksAgitation}
                  min={1}
                  max={5}
                  value={puntosCalidad}
                  onChange={(v) => setPuntosCalidad(v)}
                  style={{marginTop:"30px"}}
                />
              </Col>
            </Col>
            <Col lg={8} md={24}>
              <Col span={24}>
                <HeaderOptions>{t('headers.article.piece_properties')}</HeaderOptions>
                <Col span={24}>
                  <RenderSlider findKey={slidersKeys.hard_coat} name={t('labels.hard_coat')} min={10} max={50} unit="mm" />
                </Col>
                <Col span={24} >
                  <RenderSlider findKey={slidersKeys.hardness_required} name={t('labels.hardness_required')} min={500} max={1000} unit="HV1" />
                </Col>
              </Col>
              <Col span={24}>
                <HeaderOptions>{t('headers.article.steel_grade')}</HeaderOptions>
                <Col span={24}>
                  <Radio.Group
                    defaultValue={grades.find(grade => grade.value === state.grade).value}
                    onChange={el => handleChangueGrade({ value: el.target.value })}
                    size="large"
                    style={{ width: "100%" }}
                  >
                    {grades.map(obj => (
                      <Radio.Button style={radioStyle} key={obj.key} value={obj.value}>
                        {obj.name}
                      </Radio.Button>
                    ))}
                  </Radio.Group>
                </Col>
              </Col>
            </Col>
          </Row>
        </Col>
      </Row>
    </Wrapper>
  );
};
export default Articulo;
